import * as z from 'zod'
import { buildI18nMessage } from '~/shared/lib/i18nMessageHelper'
import {
  numberRequiredScheme,
  phoneScheme,
  stringRequiredScheme,
} from '~/shared/lib/schemas'
import { ApiModel } from './core'

const schema = z.object({
  name: stringRequiredScheme,
  full_name: stringRequiredScheme,
  inn: numberRequiredScheme,
  kpp: numberRequiredScheme,
  okpo: numberRequiredScheme,
  ogrn: numberRequiredScheme,
  phone_number: phoneScheme.optional().nullable(),
  email: z.string().email(buildI18nMessage('validate.invalid email address')),
  web_site: z.string().url(buildI18nMessage('validate.invalid url')),
  legal_address: stringRequiredScheme,
  actual_address: stringRequiredScheme,
  main_checking_account: numberRequiredScheme,
})

export type TaxiparkAttributes = z.infer<typeof schema>

export class Taxipark extends ApiModel<typeof schema> {
  static jsonApiType = 'taxiparks'

  static schema = schema
}
